<template>
  <ts-card>
    <div
      class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
    >
      <h4 class="ts-text-sm">{{ $t('teacherSubjectCode.pageTitle') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <ts-loading-banner :loading="loadingPreData">
        <form class="form-horizontal">
          <div class="row">
            <div class="col-sm-12">
              <div class="row form-group m-b-15">
                <label class="col-md-3 col-form-label required">{{
                  $t('teacherSubjectCode.academicYear')
                }}</label>
                <div class="col-md-7">
                  <select
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('ac_year_id') }"
                    v-model.number="model.ac_year_id"
                  >
                    <option value>{{ $t('select') }}</option>
                    <option
                      v-for="(acYear, index) in academicYears"
                      :key="index"
                      :value="acYear.ac_year_id"
                      >{{ acYear.ac_year }}</option
                    >
                  </select>
                  <div class="invalid-feedback" v-if="errors.has('ac_year_id')">
                    {{ errors.first('ac_year_id') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-form-label col-md-3 required">{{
                  $t('teacherSubjectCode.teacherName')
                }}</label>
                <div class="col-md-7">
                  <treeselect
                    :options="
                      teachers.map(i => ({
                        id: i.teacher_id,
                        label: i.lname_foreign + ' ' + i.fname_foreign
                      }))
                    "
                    :placeholder="$t('typeForSearch')"
                    v-model="model.teacher_id"
                    :maxHeight="120"
                    @input="getSubjectByTeacher(model.teacher_id)"
                  ></treeselect>
                  <div class="validate" v-if="errors.has('teacher_id')">
                    {{ errors.first('teacher_id') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div id="container-table">
                <table class="table ui-table table-hover">
                  <thead>
                    <tr>
                      <th style="width:14%">
                        {{ $t('teacherSubjectCode.subjectName') }}
                      </th>
                      <th style="width:25%">
                        {{ $t('teacherSubjectCode.subjectCode') }}
                      </th>
                      <th style="width:9%">
                        {{ $t('teacherSubjectCode.totalHour') }}
                      </th>
                      <th style="width: 2%" class="text-center">
                        <a href="#" class="text-primary">
                          <i class="fas fa-spinner spin" v-if="ready_fetch"></i>
                          <i
                            class="fa fa-plus"
                            v-else
                            @click.prevent="addNewRow"
                          ></i>
                        </a>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr></tr>
                    <tr v-for="(item, index) in model.details" :key="index">
                      <td width="30%">
                        <treeselect
                          :options="
                            subjectsNotIncludeSelected({
                              addedSubjects: model.details,
                              excludeSubjectId: item.subject_id
                            }).map(el => ({
                              id: el.subject_id,
                              label: el.subject_name_foreign
                            }))
                          "
                          :placeholder="$t('typeForSearch')"
                          v-model="item.subject_id"
                          :maxHeight="120"
                          :clearable="false"
                        ></treeselect>
                        <div
                          class="validate"
                          v-if="errors.has('details.' + index + '.subject_id')"
                        >
                          {{ errors.first('details.' + index + '.subject_id') }}
                        </div>
                      </td>
                      <td>
                        <input
                          type="text"
                          v-model="item.subject_code"
                          class="form-control only-border-bottom"
                          :class="{
                            'is-invalid': errors.has(
                              'details.' + index + '.subject_code'
                            )
                          }"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="
                            errors.has('details.' + index + '.subject_code')
                          "
                        >
                          {{
                            errors.first('details.' + index + '.subject_code')
                          }}
                        </div>
                      </td>
                      <td width="15%">
                        <input
                          type="number"
                          v-model.number="item.total_hours"
                          class="form-control only-border-bottom"
                          :class="{
                            'is-invalid': errors.has(
                              'details.' + index + '.total_hours'
                            )
                          }"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('details.' + index + '.total_hours')"
                        >
                          {{
                            errors.first('details.' + index + '.total_hours')
                          }}
                        </div>
                      </td>
                      <td class="text-center">
                        <a
                          href="#"
                          class="text-danger"
                          @click.prevent="removeRow(item)"
                        >
                          <i class="fa fa-trash"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-sm-12 text-right">
              <ts-button
                class="btn-default mr-2"
                @click.prevent="$emit('close')"
                >{{ $t('cancel') }}</ts-button
              >
              <ts-button
                color="primary"
                outline
                :waiting="saving_new"
                @click.prevent="saveAddNew"
                >{{ $t('saveAddNew') }}</ts-button
              >
              <ts-button
                class="btn-primary ml-2"
                @click.prevent="store"
                :waiting="saving"
                >{{ $t('save') }}</ts-button
              >
            </div>
          </div>
        </form>
      </ts-loading-banner>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'teacher-subject-code-create',
  data() {
    return {
      model: {
        ac_year_id: '',
        teacher_id: null,
        details: []
      },
      newRow: {
        subject_id: null,
        subject_code: '',
        total_hours: ''
      },
      errors: new Errors(),
      ready_fetch: false,
      saving: false,
      saving_new: false,
      loadingPreData: false
    }
  },
  created() {
    this.loadingPreData = true
    Promise.all([this.fetchAcademicYear(), this.fetchTeachers()]).then(() => {
      this.loadingPreData = false
    })
  },
  computed: {
    ...mapState('teacherSubjectCode', [
      'academicYears',
      'teachers',
      'subjects'
    ]),
    ...mapGetters('teacherSubjectCode', ['subjectsNotIncludeSelected'])
  },
  methods: {
    ...mapActions('teacherSubjectCode', ['fetchAcademicYear', 'fetchTeachers']),
    addNewRow() {
      this.errors = new Errors()
      this.model.details.push(_.clone(this.newRow))
    },
    removeRow(item) {
      this.model.details.splice(this.model.details.indexOf(item), 1)
    },
    async getSubjectByTeacher(teacher_id) {
      this.errors = new Errors()
      this.ready_fetch = true
      if (!teacher_id) {
        this.model.details = []
        this.ready_fetch = false
        return
      }
      await this.$store
        .dispatch('teacherSubjectCode/subject', teacher_id)
        .then(() => {
          this.ready_fetch = false
          this.model.details = []
          this.subjects.map(el => {
            this.model.details.push(
              _.clone({
                subject_id: el.subject_id,
                subject_code: '',
                total_hours: ''
              })
            )
          })
        })
        .catch(error => {
          this.ready_fetch = false
          this.$toasted.error(error.message)
        })
    },
    store() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('teacherSubjectCode/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.saving = false
          this.$emit('close')
        })
        .catch(error => {
          this.saving = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    saveAddNew() {
      this.errors = new Errors()
      this.saving_new = true
      this.$store
        .dispatch('teacherSubjectCode/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearForm()
          this.saving_new = false
        })
        .catch(error => {
          this.saving_new = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    clearForm() {
      this.model = {
        ac_year_id: '',
        teacher_id: null,
        details: []
      }
    }
  }
}
</script>
<style lang="css" scoped>
#container-table {
  max-height: 30vh;
  min-height: 20vh;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
::-webkit-scrollbar {
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  background: rgb(194, 194, 194);
}
table td {
  vertical-align: middle;
}
.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
  outline: none;
}
.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
}
</style>
